export const isMacOS = () => {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent.toLocaleLowerCase().includes('mac')
  }
  return false
}